//

export function getDeviceName() {
  const { userAgent } = window.navigator;
  if (userAgent.includes('iPhone')) {
    return 'iPhone';
  }
  if (userAgent.includes('iPad')) {
    return 'iPad';
  }
  if (userAgent.includes('LG')) {
    return 'LG';
  }
  if (userAgent.includes('KFA')) {
    return 'Kindle Fire';
  }
  if (userAgent.includes('Nexus')) {
    return 'Nexus';
  }
  if (userAgent.includes('Nokia')) {
    return 'Nokia';
  }
  if (userAgent.includes('Pixel')) {
    return 'Pixel';
  }
  if (userAgent.includes('SM') || userAgent.includes('GT')) {
    return 'Samsung';
  }
  if (userAgent.includes('Android')) {
    return 'Android';
  }
  if (userAgent.includes('Edge')) {
    return 'Microsoft Edge';
  }
  if (userAgent.includes('Chrome')) {
    return 'Chrome';
  }
  if (userAgent.includes('Firefox')) {
    return 'Firefox';
  }
  if (userAgent.includes('Safari')) {
    return 'Safari';
  }
  if (userAgent.includes('MSIE')) {
    return 'Microsoft Internet Explorer';
  }
  return 'Unknown Device';
}

// return whether unsupported brower or not
export const unsupportedBrowser = () => {
  const ua = navigator.userAgent;
  // const isFirefox = (ua.indexOf('Firefox/') !== -1 && ua.indexOf('Seamonkey/') === -1) || ua.indexOf('FxiOS') !== -1;
  const isInternetExplorer = ua.includes('Trident/') && (ua.includes('rv:') || ua.includes('MSIE'));
  const unsupported = isInternetExplorer;
  return unsupported;
};
